"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Valora = void 0;
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_loader_spinner_1 = require("react-loader-spinner");
var useWalletConnectConnector_1 = require("../connectors/useWalletConnectConnector");
var constants_1 = require("../constants");
var getDeepLink = function (uri) {
    return "celo://wallet/wc?uri=".concat(uri);
};
var Valora = function (_a) {
    var onSubmit = _a.onSubmit;
    var uri = (0, useWalletConnectConnector_1.useWalletConnectConnector)(onSubmit, react_device_detect_1.isMobile, getDeepLink, constants_1.WalletIds.Valora);
    return (react_1.default.createElement("div", { className: "tw-flex tw-flex-col tw-items-center" },
        react_1.default.createElement("h1", { className: "tw-text-lg dark:tw-text-gray-200 tw-font-medium" }, "Valora"),
        react_1.default.createElement("div", { className: "tw-w-64 tw-text-gray-600 dark:tw-text-gray-400 tw-text-sm tw-mt-2 tw-text-center" }, "Opening Valora Wallet. If it doesn't open, you can scan this QR code or if on a mobile device press 'Open'."),
        react_1.default.createElement("div", { className: "tw-mt-6 tw-mb-2" }, uri ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(qrcode_react_1.default, { value: uri, size: 180 }),
            react_1.default.createElement("div", { className: "tw-mt-6 tw-flex tw-items-center tw-justify-center" },
                react_1.default.createElement("a", { href: getDeepLink(uri) }, "Open valora")))) : (react_1.default.createElement("div", { className: "tw-my-8 tw-flex tw-items-center tw-justify-center" },
            react_1.default.createElement(react_loader_spinner_1.TailSpin, { color: "#666666", height: "60px", width: "60px" }))))));
};
exports.Valora = Valora;
//# sourceMappingURL=valora.js.map